import React, { useState } from 'react';
import { ZCDSelect } from '@zencity/common-ui';
import { SelectOption } from '@zencity/common-ui/lib/ZCD/ZCDFilter/types';
import { useTranslation } from 'react-i18next';
import { FieldTitle } from 'screens/WidgetGenerator/components/FieldTitle/FieldTitle';
import { ReportBuilderFilterProps } from 'screens/WidgetGenerator/reportGeneratorComponents/constants';
import { ASPECTS_LABELS, AspectValues } from 'types/aspect';

export const AspectFilter = (props: ReportBuilderFilterProps) => {
  const { value: filterValue, onChange } = props;
  const { t: translate } = useTranslation();
  const [selectedAspect, setSelectedAspect] = useState<SelectOption>(filterValue as SelectOption);

  const aspectsOptions: SelectOption[] = [
    {
      value: AspectValues.QUALITY_OF_LIFE,
      label: ASPECTS_LABELS.quality_of_life,
    },
    {
      value: AspectValues.CHARACTERISTIC,
      label: ASPECTS_LABELS.characteristic,
    },
  ];

  const handleOnSelectAspect = (selectedAspectOption: unknown) => {
    const selectedOption = selectedAspectOption as SelectOption;
    setSelectedAspect(selectedOption);
    onChange(selectedOption);
  };

  return (
    <>
      <FieldTitle title={translate('widgetGenerator.filters.questionnaire.selectAspect')} />
      <ZCDSelect
        placeholder={translate('widgetGenerator.filters.questionnaire.selectAspect')}
        options={aspectsOptions}
        onChange={handleOnSelectAspect}
        value={selectedAspect}
      />
    </>
  );
};
